import React, { useEffect, useState } from "react";
import Search from "../../../components/Search";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../features/dropdown/dropdownSlice";
import PanelAdd from "./modal/PanelAdd";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import { Dropdown, Table } from "antd";
import usersSvg from "../../../assets/svg/usersSvg.svg";
import deleteSvg from "../../../assets/svg/delete-red.svg";
import svg80 from "../../../assets/svg/svg80.svg";
import svg79 from "../../../assets/svg/svg79.svg";
import svg76 from "../../../assets/svg/svg76.svg";
import ConfirmModal from "../../../components/ConfirmModal";
import PanelMember from "./modal/PanelMember";
import InsideHeader from "../../../components/InsideHeader";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import EmtyCard from "../../../components/EmtyCard";

function PanelList() {
  const url = "v1/ap/panel/getAll";
  const urlRoles = "v1/ap/panel-roles/getAll";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, data, count } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
  }));
  const { saving } = useSelector((state) => state.save);

  const [searchInput, setsearchInput] = useState(null);
  const { open, handleCancel, handleOpen } = useModalToggle();

  const [prodd, setProdd] = useState();
  const [prodd1, setProdd1] = useState();

  const handeAddPanel = async () => {
    await setProdd();
    await setProdd1();
    await handleOpen();
  };
  const handeEditPanel = async () => {
    handleOpen();
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        paName: e.target.value == "" ? null : e.target.value,
      })
    );
  };
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = async () => {
    await setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: `v1/ap/panel/delete/${prodd?.paId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const [openDeleteMember, setOpenDeleteMember] = useState(false);
  const handleOpenDeleteMember = async (item) => {
    await setProdd1(item);
    await setOpenDeleteMember(true);
  };
  const handleCloseDeleteMember = () => {
    setOpenDeleteMember(false);
  };

  const handleDeleteMember = async () => {
    const res = await dispatch(
      save({
        url: `v1/ap/panel-members/delete/${prodd1?.pmId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      setOpenDeleteMember(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const [openPanelMember, setOpenPanelMember] = useState(false);
  const handleOpenPanelMember = async () => {
    await setProdd1();
    await setOpenPanelMember(true);
  };
  const handleClosePanelMember = () => {
    setOpenPanelMember(false);
  };
  const handleEditPanelMember = async (item) => {
    await setProdd1(item);
    await setOpenPanelMember(true);
  };

  const settingItems = [
    {
      key: "2",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={handeEditPanel}
        >
          <img src={svg80} alt="svg80" className="w-4 h-4" />
          <span className="whitespace-nowrap">Edit</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
    {
      key: "3",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={handleOpenPanelMember}
        >
          <img src={usersSvg} alt="usersSvg" className="w-4 h-4" />
          <span className="whitespace-nowrap">Add Member</span>
        </Link>
      ),
    },
    {
      key: "divider-3",
      type: "divider",
    },
    {
      key: "4",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={handleOpenDelete}
        >
          <img src={deleteSvg} alt="deleteSvg" className="w-4 h-4" />
          <span className="whitespace-nowrap">Delete</span>
        </Link>
      ),
    },
    {
      key: "divider-3",
      type: "divider",
    },
  ];

  const columns = [
    {
      title: "Member Name",
      dataIndex: "pmName",
    },
    {
      title: "Member Roles",
      dataIndex: "pmRole",
    },
    {
      title: "Email",
      dataIndex: "pmEmail",
    },
    {
      title: "Phone Number",
      dataIndex: "pmPhone",
    },
    {
      title: "Action",
      width: "150px",
      render: (item) => {
        return (
          <div className="flex items-center lg:gap-3 gap-1">
            <img
              src={svg80}
              alt="svg80"
              className="cursor-pointer"
              onClick={() => handleEditPanelMember(item)}
            />
            <img
              src={deleteSvg}
              alt="deleteSvg"
              className="cursor-pointer"
              onClick={() => handleOpenDeleteMember(item)}
            />
          </div>
        );
      },
    },
  ];

  const tableColumns = columns?.map((item) => ({
    ...item,
  }));

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    dispatch(fetchData({ url: urlRoles }));
  }, []);

  return (
    <>
      <div className="w-full h-full overflow-y-scroll">
        <InsideHeader title="Panelist" subtitle="List of Panels" back={false} />

        <div className="mt-[1.5rem] white_card flex-1 min-h-[70vh]">
          <div className="flex lg:flex-row flex-col-reverse gap-y-5 lg:items-center justify-between ">
            <div className="lg:w-[35.125rem] w-auto ">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search ..."}
              />
            </div>

            <div className="w-[150px]">
              <button onClick={() => handeAddPanel()} className="cstm-btn">
                <img src={svg76} alt="svg76" />{" "}
                <span className="">Add Panel</span>
              </button>
            </div>
          </div>

          {data && data?.length > 0 ? (
            <>
              {data?.map((panel) => (
                <div className="border border-[#DBE1EE] rounded-[.75rem] lg:p-[1.5rem] p-[.8rem] mt-[1.5rem]">
                  <Table
                    key={panel.paId}
                    rowSelection={true}
                    size={"middle"}
                    bordered={true}
                    pagination={{
                      position: ["bottomCenter"],
                      hideOnSinglePage: true,
                    }}
                    rowKey={panel?.paId}
                    columns={tableColumns}
                    dataSource={panel.panelMembers || []}
                    scroll={{
                      x: "auto",
                    }}
                    className="custom-table mt-[2rem]"
                    loading={loading}
                    title={(record) => {
                      return (
                        <div className="flex items-center justify-between">
                          <div className="text-[#0B363D] font-dmSans text-[1.125rem] font-[500]">
                            {panel?.paName}
                          </div>
                          <Dropdown
                            overlayStyle={{
                              width: "250px",
                            }}
                            trigger={"click"}
                            menu={{ items: settingItems }}
                            placement="bottom"
                          >
                            <button
                              className="max-w-[7.0625rem]  py-0 px-[.75rem] gap-[.5rem] rounded-[1.625rem] border border-[#DAA520] bg-[#F9F9F9] flex items-center min-h-[2.5rem]"
                              type="button"
                              onClick={() => setProdd(panel)}
                            >
                              Actions
                              <img src={svg79} alt="svg79" />
                            </button>
                          </Dropdown>
                        </div>
                      );
                    }}
                  />
                </div>
              ))}
            </>
          ) : (
            <div className="mt-[2rem]">
              <EmtyCard />
            </div>
          )}
        </div>
      </div>

      <PanelAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <PanelMember
        isModalOpen={openPanelMember}
        handleCancel={handleClosePanelMember}
        handleFetch={fetchTableData}
        prodd1={prodd1}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content={`Are you sure you want to delete ${prodd?.paName}`}
        type="alert"
        btnTitle="Confirm"
      />
      <ConfirmModal
        open={openDeleteMember}
        handleCancel={handleCloseDeleteMember}
        handleSubmit={handleDeleteMember}
        loading={saving}
        content={`Are you sure you want to delete ${prodd1?.pmName}`}
        type="alert"
        btnTitle="Confirm"
      />
    </>
  );
}

export default PanelList;
